import { Store } from '../../../store/player/types';

export const hasNextRecording = (store: Store): boolean => {
  const { recordingsList, recordingId, lowerBound, getRecordingIndexById } = store.getState();
  if (!recordingsList.length) {
    return false;
  }

  return getRecordingIndexById(recordingId) < recordingsList.length - 1 + lowerBound;
};
